// import * as MD from '@material-ui/core';
import * as React from 'react';
import { Layout } from '../Components/Layout';
import { setDrawerContent, setPageContent } from '../Store/Layout/Actions';
import { Route, RouteComponentProps } from 'react-router-dom';
import {  IApplicationState, IConnectedReduxProps } from '../Store';
// IApplicationState,
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { ILayoutState } from '../Store/Layout/Types';
import { DashboardDrawer } from '../Components/Sidebar/DashboardDrawer';
import { DeclarationsCSAContent } from '../Components/Elections/declarationsCSA';

interface IPropsFromState {
    layout: ILayoutState;
}

interface IPropsFromDispatch {
    setDrawerContent: typeof setDrawerContent;
    setPageContent: typeof setPageContent;
}

type AllProps =
    IPropsFromDispatch &
    IPropsFromState &
    RouteComponentProps<{}> &
    IConnectedReduxProps;

export class declarationsCSAPage extends React.Component<AllProps> {
    public componentDidMount() {
        this.props.setPageContent(<Route component={DeclarationsCSAContent} />);
        this.props.setDrawerContent(<Route component={DashboardDrawer} />)
    }

    public render(): React.ReactNode {
        return (
            <Route component={Layout} />
        );
    }
}

const mapStateToProps = ({ layout }: IApplicationState) => ({
    layout,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    setDrawerContent: (c: React.ReactNode) => dispatch(setDrawerContent(c)),
    setPageContent: (c: React.ReactNode) => dispatch(setPageContent(c)),
});

export const declarationsCSA = connect(mapStateToProps, mapDispatchToProps)(declarationsCSAPage);
